import React from "react";
import { connect } from "react-redux";

import { defineMessages, useIntl } from "react-intl";

import MapTool from "@mapmycustomers/shared/enum/map/MapTool";
import { MultiPin } from "@mapmycustomers/shared/types/map";

import {
  getMapLassoPathsCount,
  getMapViewTool,
  getMultiPin,
  getRecordsListTotal,
  getRecordsListTotalBeforeFilter,
  isRecordsListFiltered,
} from "@app/scene/map/store/selectors";
import { RootState } from "@app/store/rootReducer";

import styles from "./Title.module.scss";

interface Props {
  filtered: boolean;
  multiPin?: MultiPin;
  pathsCount: number;
  selectedTool?: MapTool;
  totalFilteredRecords: number;
  totalRecords: number;
}

const messages = defineMessages({
  default: {
    id: "map.recordList.mapMode.title.default",
    defaultMessage: "Records in view",
    description: "Records List default title",
  },
  multiPin: {
    id: "map.recordsList.multiPin.title",
    defaultMessage: "Multiple Records",
    description: "Records list for multi-pin - title",
  },
});

const Title: React.FC<Props> = ({
  filtered,
  multiPin,
  selectedTool,
  totalFilteredRecords,
  totalRecords,
}) => {
  const intl = useIntl();

  const isMultiPinMode = !!multiPin && selectedTool !== MapTool.LASSO;

  return isMultiPinMode ? (
    <>{intl.formatMessage(messages.multiPin)}</>
  ) : (
    <div className={styles.container}>
      {intl.formatMessage(messages.default)}
      {filtered ? (
        <span className={styles.count}>
          {totalFilteredRecords} / {totalRecords}
        </span>
      ) : (
        <span className={styles.count}>{totalFilteredRecords}</span>
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  filtered: isRecordsListFiltered(state),
  multiPin: getMultiPin(state),
  pathsCount: getMapLassoPathsCount(state),
  selectedTool: getMapViewTool(state),
  totalFilteredRecords: getRecordsListTotal(state),
  totalRecords: getRecordsListTotalBeforeFilter(state),
});

export default connect(mapStateToProps)(Title);
